import React, { useContext, useEffect, useState } from "react";
import { Card, Heading, Pane, Spinner, Text } from "evergreen-ui";
import ControlHubContext from "../contexts/controlhub";
import { API_URL } from "../config";

import ConfigureBankButton from "../components/BankAccountConfiguration/ConfigureBankButton";
import BankAccountDetails from "../components/BankAccountConfiguration/BankAccountDetails";

function BillingConfirmationScreen({ service, setLoadingState }) {
  const { currentCompanyId, cookieSession } = useContext(ControlHubContext);
  const [isLoading, setIsLoading] = useState(true);
  const [billing, setBilling] = useState(null);

  useEffect(() => {
    if (!cookieSession || !currentCompanyId) return;

    setIsLoading(true);
    fetch(`${API_URL}/billing?companyId=${currentCompanyId}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setBilling(data))
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setIsLoading(false));
  }, [cookieSession, currentCompanyId]);

  if (isLoading) {
    return (
      <Pane
        height={240}
        alignItems="center"
        justifyContent="center"
        display="flex"
      >
        <Spinner />
      </Pane>
    );
  }

  return (
    <Pane paddingX={48}>
      <Pane display="flex" paddingY={16}>
        <Pane flex={1} alignItems="center" display="flex">
          <Heading size={500}>Billing Confirmation</Heading>
        </Pane>
      </Pane>
      <Card background="greenTint" elevation={1} maxWidth="33%" padding={32}>
        <Text>
          Your payment has been submitted. You will receive your receipt by
          email.
        </Text>
      </Card>

      {billing && billing.requires_plaid_integration && currentCompanyId && (
        <ConfigureBankButton
          billingInfo={billing}
          service={service}
          setLoadingState={setLoadingState}
        />
      )}

      {billing && billing.has_bank_configured && (
        <BankAccountDetails accountDetail={billing.bank_account} />
      )}
    </Pane>
  );
}

export default BillingConfirmationScreen;
